var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 4.47454V3.9087C4.375 2.5962 5.43083 1.30704 6.74333 1.18454C8.30667 1.03287 9.625 2.2637 9.625 3.79787V4.60287",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25014 12.8346H8.75014C11.0951 12.8346 11.5151 11.8955 11.6376 10.7521L12.0751 7.25214C12.2326 5.8288 11.8243 4.66797 9.33348 4.66797H4.66681C2.17598 4.66797 1.76764 5.8288 1.92514 7.25214L2.36264 10.7521C2.48514 11.8955 2.90514 12.8346 5.25014 12.8346Z",
    stroke: "#393939",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03944 6.9987H9.04468",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95545 6.9987H4.96069",
    stroke: "#393939",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart_Icon.5f3d8d43a61078394ea8e243b5200788.svg";
export { ForwardRef as ReactComponent };